let listeners = [];

const toast = {
  error:   (msg) => listeners.forEach(fn => fn({ type: 'error',   msg })),
  success: (msg) => listeners.forEach(fn => fn({ type: 'success', msg })),
  warning: (msg) => listeners.forEach(fn => fn({ type: 'warning', msg })),
  subscribe: (fn) => {
    listeners.push(fn);
    return () => { listeners = listeners.filter(l => l !== fn); };
  },
};

export default toast;
